import {User} from "../../../../../api/accessControl/User.ts";
import {useParams} from "react-router-dom";
import Shell from "../../../../../components/specific/Shell.tsx";
import RelativeLoadingFrame from "../../../../../components/RelativeLoadingFrame.tsx";
import {BackendApi} from "../../../../../api/api.ts";
import {MatchDetailsView} from "../../../../../components/matches/MatchDetailsView.tsx";
import {useMatchDetailsByMatchId} from "../../../../../hooks/useMatchDetails.ts";

export default function PartnerMatchPage({currentUser}: { currentUser: User }) {
    const {matchId} = useParams<{ matchId: string }>();
    const api = new BackendApi(currentUser.getToken());
    const {data: match, isLoading, error, reload} = useMatchDetailsByMatchId(api, matchId ?? null);

    async function handleUnmatchParts(billIds: string[], transactionIds: string[]) {
        if (!matchId) return;
        await api.Reconciliation__manuallyUnmatch({
            match_id: matchId,
            bill_ids: billIds,
            transaction_ids: transactionIds,
        });
        await reload();
    }

    async function handleUnmatchAll() {
        if (!match) return;
        await handleUnmatchParts(
            match.bill_parts.map((b) => b.id),
            match.transaction_parts.map((t) => t.id),
        );
    }

    return (
        <Shell currentUser={currentUser} isLoading={false}>
            <div className="w-full max-w-5xl mx-auto">
                <h1 className="weight-600 text-3xl mb-6">Match</h1>
                <RelativeLoadingFrame isLoading={isLoading}>
                    {error ? (
                        <div className="flex items-center justify-center h-64">
                            <p className="text-gray-500">{error}</p>
                        </div>
                    ) : match ? (
                        <MatchDetailsView
                            match={match}
                            onUnmatchPart={handleUnmatchParts}
                            onUnmatchAll={handleUnmatchAll}
                        />
                    ) : (
                        <div className="flex items-center justify-center h-64">
                            <p className="text-gray-500">Geen match gevonden.</p>
                        </div>
                    )}
                </RelativeLoadingFrame>
            </div>
        </Shell>
    );
}
